// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__A+kIW","active":"MainNavigation_active__A3hGx","logo":"MainNavigation_logo__AQtwn","img":"MainNavigation_img__Gak47"};